var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14142 9.23071L5.53044 13.2308H9.72201L7.33299 9.23071H3.14142ZM4.57634 4.61536H0.384766L2.77378 8.61541H6.96536L4.57634 4.61536ZM11.9122 8.61541L9.52322 4.61536H5.33495L7.72397 8.61541H11.9122ZM16.8589 8.61541L14.4699 4.61536H10.2816L12.6706 8.61541H16.8589ZM13.0382 9.23071L15.4273 13.2308H19.6155L17.2265 9.23071H13.0382ZM11.6394 13.2308H14.6689L12.2796 9.23071H8.09136L10.4783 13.227V16.1537H8.41396V16.923H13.7214V16.1537H11.6394V13.2308Z",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarDark);
export default __webpack_public_path__ + "static/media/SolarDark.98644a4e.svg";
export { ForwardRef as ReactComponent };